import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/jsx-props-no-spreading */
import { isNil } from '@newfront-insurance/core';
import kebabCase from 'lodash/kebabCase';
import type { JSX } from 'react';
import NumberFormat from 'react-number-format';
import styled from 'styled-components';
import { fontFamilies } from '../../theme';
import { colors } from '../../theme/colors';
type ChangeHandler = (value?: number) => void;
interface Props {
  allowNegative?: boolean;
  decimalScale?: number;
  defaultValue?: string | number;
  disabled?: boolean;
  displayDollarSign?: boolean;
  name: string;
  onChange?: ChangeHandler;
  placeholder?: string;
  testId?: string;
  value?: string | number;
  style?: {
    borderColor?: string;
    borderRadius?: string;
    overflow?: string;
    compact?: boolean;
  };
  isInvalid?: boolean;
  autoComplete?: 'on' | 'off';
}
const StyledCurrencyInput = styled.div<Pick<Props, 'style' | 'isInvalid'>>`
  border: 1px;
  border-style: solid;
  border-color: ${({
  style,
  isInvalid
}) => isInvalid && colors.fire[500] || style?.borderColor || colors.steel[200]};
  border-radius: ${({
  style
}) => style?.borderRadius || '3px'};
  color: #000;
  display: flex;
  overflow: ${({
  style
}) => style?.overflow};

  &:focus,
  &:focus-within,
  &:active:not(:disabled) {
    border-color: ${colors.brand[400]};
  }
`;
const StyledDollarSign = styled.div`
  background-color: ${colors.steel[100]};
  border-right: 1px solid ${colors.steel[75]};
  color: ${colors.steel[300]};
  font-family: ${fontFamilies.body};
  position: relative;
  width: 40px;

  &:after {
    content: '$';
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
export function CurrencyInput(props) {
  const $ = _c(40);
  let autoComplete;
  let defaultValue;
  let disabled;
  let isInvalid;
  let name;
  let onChange;
  let otherProps;
  let propTestId;
  let style;
  let t0;
  let t1;
  let t2;
  let t3;
  let value;
  if ($[0] !== props) {
    ({
      allowNegative: t0,
      decimalScale: t1,
      defaultValue,
      disabled,
      displayDollarSign: t2,
      name,
      onChange,
      placeholder: t3,
      testId: propTestId,
      value,
      style,
      isInvalid,
      autoComplete,
      ...otherProps
    } = props);
    $[0] = props;
    $[1] = autoComplete;
    $[2] = defaultValue;
    $[3] = disabled;
    $[4] = isInvalid;
    $[5] = name;
    $[6] = onChange;
    $[7] = otherProps;
    $[8] = propTestId;
    $[9] = style;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = value;
  } else {
    autoComplete = $[1];
    defaultValue = $[2];
    disabled = $[3];
    isInvalid = $[4];
    name = $[5];
    onChange = $[6];
    otherProps = $[7];
    propTestId = $[8];
    style = $[9];
    t0 = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    value = $[14];
  }
  const allowNegative = t0 === undefined ? false : t0;
  const decimalScale = t1 === undefined ? 2 : t1;
  const displayDollarSign = t2 === undefined ? true : t2;
  const placeholder = t3 === undefined ? "0.00" : t3;
  let t4;
  if ($[15] !== name || $[16] !== propTestId) {
    t4 = propTestId ?? (name ? kebabCase(name) : undefined);
    $[15] = name;
    $[16] = propTestId;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const testId = t4;
  const compactClassName = style?.compact ? "py-[4px] px-[9px] leading-5" : "py-[8px] px-[12px] leading-[22px]";
  const className = `font-body w-full border-none text-base text-steel-500 placeholder:text-steel-300 disabled:bg-steel-100 focus:outline-hidden ${compactClassName}`;
  let t5;
  if ($[18] !== displayDollarSign) {
    t5 = displayDollarSign ? <StyledDollarSign /> : null;
    $[18] = displayDollarSign;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== onChange) {
    t6 = valueObject => {
      if (onChange) {
        onChange(valueObject.floatValue);
      }
    };
    $[20] = onChange;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const t7 = isNil(value) ? "" : value;
  let t8;
  if ($[22] !== allowNegative || $[23] !== autoComplete || $[24] !== className || $[25] !== decimalScale || $[26] !== defaultValue || $[27] !== disabled || $[28] !== name || $[29] !== otherProps || $[30] !== placeholder || $[31] !== t6 || $[32] !== t7 || $[33] !== testId) {
    t8 = <NumberFormat allowNegative={allowNegative} decimalScale={decimalScale} defaultValue={defaultValue} disabled={disabled} fixedDecimalScale={true} isNumericString={true} name={name} onValueChange={t6} placeholder={placeholder} thousandSeparator={true} value={t7} data-testid={testId} {...otherProps} className={className} autoComplete={autoComplete} />;
    $[22] = allowNegative;
    $[23] = autoComplete;
    $[24] = className;
    $[25] = decimalScale;
    $[26] = defaultValue;
    $[27] = disabled;
    $[28] = name;
    $[29] = otherProps;
    $[30] = placeholder;
    $[31] = t6;
    $[32] = t7;
    $[33] = testId;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  let t9;
  if ($[35] !== isInvalid || $[36] !== style || $[37] !== t5 || $[38] !== t8) {
    t9 = <StyledCurrencyInput style={style} isInvalid={isInvalid}>{t5}{t8}</StyledCurrencyInput>;
    $[35] = isInvalid;
    $[36] = style;
    $[37] = t5;
    $[38] = t8;
    $[39] = t9;
  } else {
    t9 = $[39];
  }
  return t9;
}